import { startOfYear, subDays, subMonths } from 'date-fns'
import { useMemo } from 'react'

import * as S from '../DatePicker.styles'
import { CustomViewPreset, ViewComponentProps } from '../DatePicker.types'
import { getCustomViewPresets } from '../DatePicker.utils'

export const CustomView = ({ preset, presets, onChange }: ViewComponentProps) => {
  const customViewPresets = useMemo(() => presets ?? getCustomViewPresets(), [presets])

  const handleSelectPreset = (newPreset: CustomViewPreset) => {
    const endDate = new Date()
    const startDateByPreset: Record<CustomViewPreset, Date> = {
      '7d': subDays(endDate, 7),
      '30d': subDays(endDate, 30),
      '90d': subDays(endDate, 90),
      '6m': subMonths(endDate, 6),
      '12m': subMonths(endDate, 12),
      ytd: startOfYear(endDate),
    }

    onChange({
      value: { startDate: startDateByPreset[newPreset], endDate },
      metadata: { preset: newPreset },
    })
  }

  return (
    <S.ViewGrid $marginTop={0}>
      {customViewPresets.map(customViewPreset => (
        <S.ViewPresetButton
          key={`custom-view-preset-${customViewPreset}`}
          aria-selected={customViewPreset === preset}
          onClick={() => handleSelectPreset(customViewPreset)}
        >
          {customViewPreset.toUpperCase()}
        </S.ViewPresetButton>
      ))}
    </S.ViewGrid>
  )
}
